import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { get, orderBy } from "lodash";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

const ScrollTable = (props) => {

    const {
        headers = [],
        data = [],
        height = "30rem"
    } = props;

    const [sortData, setSortData] = useState({ key: null, direction: null })

    const [dataTmp, setData] = useState(data || []);

    const handeSortClick = (key) => {
        setSortData((prev) => ({ key, direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc" }))
    }


    useEffect(() => {
        setData(orderBy(data, [sortData?.key], [sortData?.direction]));
    }, [data])

    useEffect(() => {
        setData(orderBy(dataTmp, [sortData?.key], [sortData?.direction]));
    }, [sortData])

    return <TableContainer className="ScrollTable" sx={{ maxHeight: height, minHeight: height, overflowY: 'auto', overflowX:"hidden !important" }}  >
        <Table stickyHeader>
            <TableHead >
                <TableRow>
                    {headers.map((header) => <TableCell sx={{ maxWidth:`${header?.width}`, width: `${header?.width}`, backgroundColor: "var(--BMX-table-header-bg) !important" }} key={header.key}><TableSortLabel hideSortIcon={!header?.name} active={header.key === sortData.key} onClick={() => handeSortClick(header.key)} direction={`${header.key === sortData.key ? sortData.direction : "asc"}`} >{header.name}</TableSortLabel></TableCell>)}
                </TableRow>
            </TableHead>
            <TableBody>
                {dataTmp.map((row, idx) => <TableRow sx={{backgroundColor: row?.selected?"var(--BMX-table-header-bg) !important":"inherit" }} key={idx}>
                    {headers.map((header) => <TableCell sx={{ maxWidth:`${header?.width}`, width: `${header?.width}`, textAlign: header.key === "button" ? "end" : "inherit", padding: header.key === "button" ? "0 16px 0 16px" : ""  }} key={`${idx}-${header.key}`}>{get(row, header.key, header.key === "button" ? '' : '-')}</TableCell>)}
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer>

}

ScrollTable.propTypes = {
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    height: PropTypes.string
};

export default ScrollTable;